module.exports = __webpack_public_path__ + "static/media/LearnCreatorHowItWorks1.90de92f8.png";